<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">{{translations('navbar.purchase_management')}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{translations('payment.archive_account_payable')}}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="d-flex flex-wrap justify-content-between align-items-center mb-4">
        <div class="form-inline">
          <div class="form-group mr-1">
            <input id='dtSearch' type="text" class="form-control" v-model='dtSearch' :placeholder="translations('common.keyword_search')">
          </div>
          <div class="form-group mr-3">
            <v-select
              :value="master_clients.find(m => m.id === partner_id) || ''"
              :options="master_clients"
              label="name"
              :placeholder="translations('payment.supplier')"
              id="partner_id"
              @input="changedPartner">
            </v-select>
          </div>
          <div class="form-group mr-3 d-flex align-items-center">
            <span class="text-nowrap mr-1">{{translations('payment.date')}}</span>
<!--            <input v-model="aggregatedAt" type="date" class="form-control" @blur='triggerDateFilter()' @focus='tempDateField = aggregatedAt'>-->
            <input v-model="aggregatedAt" type="date" class="form-control">
          </div>
          <div class="form-group mr-2">
            <div class="form-check">
              <input v-model="displayAll" class="form-check-input pointer-clickable" id="displayAll" type="checkbox" value="" >
              <label class="form-check-label pointer-clickable" for="displayAll">
                {{ translations('common.display_all') }}
              </label>
            </div>
          </div>
          <div class="form-group">
            <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{translations('common.search')}}</button>
          </div>
        </div>
        <div class="form-inline justify-content-end">
          <div class="form-group" style="margin: 1px 10px 0 0">
            <button class="btn btn-primary btn-sm" type="button" @click="exportCsv">{{translations('common.csv_export')}}</button>
          </div>
          <p class="mb-0">{{translations('payment.total_accounts_payable')}}：<span id="payable-sum" class="font-weight-bold">{{ sumTotalAccountPayable.toLocaleString() }}</span></p>
        </div>
      </div>
      <div class="table-scroll mb-4">
        <v-data-table
          class="table table-striped table-hover table-800"
          item-key="name"
          :headers="[
            { text: 'No', value: '', sortable: false },
            { text: this.translations('payment.date'), value: 'base_date' },
            { text: this.translations('payment.payment_destination'), value: 'partner_name' },
            { text: this.translations('payment.accounts_payable_previous'), value: 'previous_accounts_payable' },
            { text: this.translations('payment.current_accounts_payable'), value: 'accounts_payable' },
            { text: this.translations('payment.withdrawal_amount_this_time'), value: 'payment' },
            { text: this.translations('payment.accounts_payable_balance'), value: 'total_accounts_payable' },
          ]"
          :items="payable"
          hide-default-footer
          :options.sync="options"
          :server-items-length="totalCount"
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
          <tbody class="nowrap">
            <template v-if="!isEmpty">
            <tr v-for="(item, i) in items" :key='i' data-href="">
              <td>{{i + 1}}</td>
              <td>{{ $invoiceTools.formatDate(item.base_date + '') }}</td>
              <td>{{ item.partner_name }}</td>
              <td class="right">{{ $invoiceTools.moneyDelimiter(item.previous_accounts_payable) }}</td>
              <td class="right">{{ $invoiceTools.moneyDelimiter(item.accounts_payable) }}</td>
              <td class="right">{{ $invoiceTools.moneyDelimiter(item.payment) }}</td>
              <td class="right">{{ $invoiceTools.moneyDelimiter(item.total_accounts_payable) }}</td>
            </tr>
            </template>
            <template v-else>
              <tr class="odd">
                <td valign="top" colspan="12" class="dataTables_empty">{{ isEmptyMsg }}</td>
              </tr>
            </template>
          </tbody>
          </template>
        </v-data-table>
      </div>
      <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>
    </div>
    <vue-element-loading :active="isSearching" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'
import { saveAs } from 'file-saver'
import Papa from 'papaparse'
import encoding from 'encoding-japanese'

export default {
  name: 'ArchiveAccountsPayable',
  props: {},
  components: {
    VueElementLoading
  },
  computed: {
    ...mapState(['currentLanguage']),
    master_clients () {
      return this.$store.getters['Master/getPayTo']
    }
  },
  data () {
    return {
      dtSearch: this.$storage.get('ArchiveAccountsPayable:dtSearch') || '',
      isLoading: false,
      isSearching: false,
      partner_id: 0,
      aggregatedAt: this.$invoiceTools.getCurrentFormatDate(),
      payable: [],
      isEmpty: false,
      isEmptyMsg: '',
      tempDateField: '',
      page: 1,
      pageCount: null,
      totalCount: 0,
      sumTotalAccountPayable: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      displayAll: false
    }
  },
  watch: {
    // dtSearch (v) {
    //   this.$storage.set('ArchiveAccountsPayable:dtSearch', v) // KEEP KEYWORD
    // },
    page () {
      this.triggerFilter()
    },
    options: {
      handler () {
        let visitCount = Number(localStorage.getItem('visitCountAccountPayable')) || 0
        if (visitCount > 0) {
          this.initList()
        }
      },
      deep: true
    }
  },
  created: async function () {
    this.$store.dispatch('Master/checkPayTo')
    this.$storage.set('ArchiveAccountsPayableParam:aggregated_at', this.aggregatedAt)
    let storedFilter = this.$storage.get('ArchiveAccountsPayableParam')

    if (storedFilter) {
      this.partner_id = storedFilter.partner_id ? parseInt(storedFilter.partner_id) : 0
      this.aggregatedAt = storedFilter.aggregated_at
      this.options.sortBy = storedFilter.order_by
      this.options.sortDesc = storedFilter.is_desc
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },

    getFilterTxt (obj, input, output, _default) {
      if (input) {
        if (input === 0) return _default
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    initList () {
      if (this.page !== 1) {
        this.page = 1
      } else {
        this.triggerFilter()
      }
    },

    async triggerFilter (field, val) {
      try {
        if (!this.aggregatedAt) {
          this.$toastr.warning(this.translations('payment.notice_select_date'), '')
          return
        }

        if (this.displayAll) {
          this.$storage.set('accounts_payable_display_all', this.displayAll)
          this.options.itemsPerPage = -1 // DISPLAY ALL
        } else {
          this.options.itemsPerPage = 10 // DISPLAY 10 ROWS
        }

        this.isSearching = true

        const offset = (this.page - 1) * this.options.itemsPerPage
        const limit = this.options.itemsPerPage
        const orderBy = JSON.parse(JSON.stringify(this.options.sortBy))
        const isDesc = JSON.parse(JSON.stringify(this.options.sortDesc))

        let params = {
          partner_id: this.partner_id,
          aggregated_at: this.aggregatedAt,
          search: this.dtSearch,
          order_by: orderBy,
          is_desc: isDesc,
          offset: offset,
          limit: limit
        }
        this.$storage.set('ArchiveAccountsPayableParam', params)
        console.log('ArchiveAccountsPayable:triggerFilter: ', params)

        try {
          let filteredPayableList = await this.$http.post(this.$api_url.payable_list, params)
          let $data = filteredPayableList.data
          if ($data.status === true) {
            this.isEmpty = false
            this.isEmptyMsg = ''
            this.payable = $data.list
            localStorage.setItem('visitCountAccountPayable', this.payable.length)
            this.totalCount = Number($data.total_count)
            this.sumTotalAccountPayable = $data.sum_total_account_payable
          } else {
            this.payable = []
          }
        } catch (error) {
          console.log('ArchiveAccountsPayable:listAccountsPayable:catch(error): ', error)
          this.$toastr.error(this.translations('payment.notice_failed'), this.translations('common.error'))
        }
        this.isSearching = false
      } catch (e) {
        this.isEmpty = true
        this.isEmptyMsg = this.translations('payment.notice_failed')
        this.isSearching = false
        console.log('ArchiveAccountsPayable:API:triggerFilter: error: ', e)
        this.$toastr.error(this.translations('payment.notice_failed'), this.translations('common.error'))
      }
    },

    // triggerDateFilter (source) {
    //   if (!this.aggregatedAt) {
    //     this.$toastr.warning('日付を選択してください。', '')
    //     return
    //   }
    //   if (this.aggregatedAt !== this.tempDateField) {
    //     this.triggerFilter()
    //   }
    // },

    changedPartner (event) {
      if (!event) {
        this.partner_id = 0
        return
      }
      this.partner_id = event.id
    },

    submitSearch () {
      this.initList()
    },

    async exportCsv (field, val) {
      try {
        if (!this.aggregatedAt) {
          this.$toastr.warning(this.translations('payment.notice_select_date'), '')
          return
        }

        this.isSearching = true
        const orderBy = JSON.parse(JSON.stringify(this.options.sortBy))
        const isDesc = JSON.parse(JSON.stringify(this.options.sortDesc))

        let params = {
          partner_id: this.partner_id,
          aggregated_at: this.aggregatedAt,
          search: this.dtSearch,
          order_by: orderBy,
          is_desc: isDesc
        }

        this.$storage.set('ArchiveAccountsPayableParam', params)
        console.log('ArchiveAccountsPayable:exportCsv: ', params)

        try {
          let filteredPayableList = await this.$http.post(this.$api_url.payable_csv, params)
          let $data = this.$invoiceTools.prepareResult(filteredPayableList.data, 'list', 'ArchiveAccountsPayable:listAccountsPayable')
          if ($data.success === true) {
            this.isEmpty = false
            this.isEmptyMsg = ''
            this.saveCsv_($data.data)
          } else {
            this.payable = []
          }
        } catch (error) {
          console.log('ArchiveAccountsPayable:listAccountsPayable:catch(error): ', error)
          this.$toastr.error(this.translations('payment.notice_failed'), this.translations('common.error'))
        }
        this.isSearching = false
      } catch (e) {
        this.isEmpty = true
        this.isEmptyMsg = this.translations('payment.notice_failed')
        this.isSearching = false
        console.log('ArchiveAccountsPayable:API:triggerFilter: error: ', e)
        this.$toastr.error(this.translations('payment.notice_failed'), this.translations('common.error'))
      }
    },

    saveCsv_ (list) {
      const data = []
      list.forEach(item => {
        data.push([
          item.base_date,
          item.partner_name,
          item.previous_accounts_payable,
          item.accounts_payable,
          item.payment,
          item.total_accounts_payable
        ])
      })
      let csv = ''
      csv = Papa.unparse({
        fields: [
          this.translations('payment.date'),
          this.translations('payment.payment_destination'),
          this.translations('payment.accounts_payable_previous'),
          this.translations('payment.current_accounts_payable'),
          this.translations('payment.withdrawal_amount_this_time'),
          this.translations('payment.accounts_payable_balance')
        ],
        data: data
      })

      const unicodeList = encoding.stringToCode(csv)
      const sjisArray = encoding.convert(unicodeList, 'SJIS', 'UNICODE')
      const uInt8List = new Uint8Array(sjisArray)
      const content = new Blob([uInt8List], { type: 'text/csv' })
      const d = new Date()
      const filename = this.translations('payment.account_payable_') + d.getFullYear() +
        ('0' + (d.getMonth() + 1)).slice(-2) +
        ('0' + d.getDate()).slice(-2) + '_' +
        ('0' + d.getHours()).slice(-2) +
        ('0' + d.getMinutes()).slice(-2) +
        ('0' + d.getSeconds()).slice(-2) + '.csv'
      saveAs(content, filename)
      this.isLoading = false
    }
  }
}
</script>

<style>
#tbl-accounts-payable_wrapper .col-sm-12{
  padding-right: 0 !important;
}
</style>
